import type { BaseItemSchema } from "@memorang/types/src/session/new-session";
import type { CheckboxType } from "../components/dialogs/ReviewAnswersDialog";

const getFilteredChildrenItems = (
	baseItems: BaseItemSchema[],
	filters: CheckboxType[],
	isSummativeTest?: boolean,
) => {
	// biome-ignore lint/complexity/noExcessiveCognitiveComplexity: <explanation>
	const filteredItems = baseItems.filter(({ answer }) => {
		const hasSelection = answer && answer.selectedChoiceIds?.length! > 0;

		if (
			filters.includes("correct") &&
			filters.includes("incorrect") &&
			filters.includes("skipped") &&
			filters.includes("almostcorrect") &&
			filters.includes("marked")
		) {
			return answer != null;
		}
		if (filters.includes("correct") && filters.includes("incorrect")) {
			return answer
				? answer.correct != null && (isSummativeTest ? true : hasSelection)
				: false;
		}
		if (filters.includes("correct") && filters.includes("skipped")) {
			return answer ? answer.correct || !(hasSelection || answer.score) : false;
		}

		if (filters.includes("marked") && filters.includes("correct")) {
			return (answer ? answer.correct : false) || answer?.marked;
		}
		if (filters.includes("marked") && filters.includes("incorrect")) {
			return (answer ? !answer.correct : false) || answer?.marked;
		}
		if (filters.includes("marked") && filters.includes("skipped")) {
			return (
				(answer ? answer.correct || !(hasSelection || answer.score) : false) ||
				answer?.marked
			);
		}
		if (filters.includes("incorrect") && filters.includes("skipped")) {
			return answer
				? !(answer.correct && (hasSelection || answer.score))
				: false;
		}
		if (filters.includes("almostcorrect")) {
			return answer ? answer.score! >= 50 && answer.score! <= 84 : false;
		}

		if (filters.includes("correct") && hasSelection) {
			return answer ? answer.correct : false;
		}
		if (filters.includes("incorrect")) {
			const result = answer
				? !answer.correct && (isSummativeTest ? true : hasSelection)
				: false;
			return result;
		}
		if (filters.includes("skipped")) {
			return answer ? !(hasSelection || answer.score) : false;
		}
		if (filters.includes("marked")) {
			return answer?.marked;
		}
		return false;
	});
	return filteredItems;
};

export const getFilteredSessionItems = (
	sessionItems: BaseItemSchema[],
	filters: CheckboxType[],
	isSummativeTest?: boolean,
) => {
	const filteredItems = getFilteredChildrenItems(
		sessionItems,
		filters,
		isSummativeTest,
	);
	return filteredItems;
};
